import type { CmsApiPersonaQuizBlockData } from '#/modules/cms/api/types/blocks/CmsApiPersonaQuizBlock';
import type { CmsBlockMapping } from '#/modules/cms/blocks/CmsBlockMapping';
import { CmsMappedBlockWidth } from '#/modules/cms/mappers/CmsMappedBlockWidth';
import { dynamic } from '#/utils/dynamic';

export const CmsPersonaQuizBlockMapping: CmsBlockMapping<CmsApiPersonaQuizBlockData> =
  {
    invariant: [],
    width: CmsMappedBlockWidth.NARROW,
    Component: dynamic(
      () =>
        import('./CmsPersonaQuizBlock').then((m) => ({
          default: m.CmsPersonaQuizBlock,
        })),
      { strategy: 'always' },
    ),
  };
